export default "/assets/images/icon-doller.14bfa27d42169852.svg";